import React from 'react';
import { Button } from '@mui/material';

interface ActionButtonConfig {
  label: string;
  isVisible?: boolean;
  isDisabled?: boolean;
}

export const ActionFooter = (props: {
  primaryButton?: ActionButtonConfig;
  secondaryButton?: ActionButtonConfig;
  tertiaryButton?: ActionButtonConfig;
  onPrimaryButtonClick?: () => void;
  onSecondaryButtonClick?: () => void;
  onTertiaryButtonClick?: () => void;
}) => {
  return (
    <div
      className="action-footer"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        gap: '10px',
      }}
    >
      {props.tertiaryButton && (
        <Button
          variant="text"
          disabled={props.tertiaryButton.isDisabled}
          onClick={() => props.onTertiaryButtonClick?.()}
        >
          {props.tertiaryButton.label}
        </Button>
      )}
      {props.secondaryButton && (
        <Button
          variant="outlined"
          disabled={props.secondaryButton.isDisabled}
          onClick={() => props.onSecondaryButtonClick?.()}
        >
          {props.secondaryButton.label}
        </Button>
      )}
      {props.primaryButton && (
        <Button
          variant="contained"
          color="primary"
          disabled={props.primaryButton.isDisabled}
          onClick={() => props.onPrimaryButtonClick?.()}
        >
          {props.primaryButton.label}
        </Button>
      )}
    </div>
  );
};
